// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  stage: "Dev",
  type: 'dev',
  release: "RELEASE_COMMIT",
  apiUrl: "https://devdatonapi.sarasanalytics.com/",
  subscriptionApiUrl:
    "https://dev-subscription-service.sarasanalytics.com/v1/api",
  apiUrlSourceService: "https://dev-source-service.sarasanalytics.com/v1/api",
  // studioApiUrl: 'https://devdatonapi.sarasanalytics.com/connectorStudio/sourceTemplate',
  studioApiUrl: "https://devdatonapi.sarasanalytics.com/connector-studio",
  marketingPricingPageLink:
    "https://sarasanalytics.com/staging/choose-your-right-plan/",
  notificationApiUrl: `https://dev-notifications.sarasanalytics.com/v1/api`,
  monitoringApiUrl: `https://dev-monitoring-service.sarasanalytics.com/v1/api`,
  userServiceApiUrl: `https://dev-user-service.sarasanalytics.com/v1/api`,
  vmUrl: 'https://dev-notifications.sarasanalytics.com/v1/api/',
  insightsApiUrl: 'https://dev-insights-service.sarasanalytics.com',
  mixpanelProjectToken: '7fbb8d4879b82bcc65bbda14b81232fc',
  chargeBeeSite: 'sarasanalytics-test',
  agGridLicense: 'Using_this_{AG_Grid}_Enterprise_key_{AG-085730}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Saras_Analytics_LLC}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{2_May_2026}____[v3]_[01]_MTc3NzY3NjQwMDAwMA==04a53dc5e4f7c2f25891868e2381708a',
  glowroot: {
    server1: 'http://104.198.140.144:4000',
    server2: 'http://35.184.113.141:4000'
  },
  firebaseConfig : {
      apiKey: 'AIzaSyBb_9IO142S5YK3VSOEfqrAQoOaawk9c78',
      authDomain: 'dev-daton-37754.firebaseapp.com',
      projectId: 'dev-daton-37754',
      storageBucket: 'dev-daton-37754.appspot.com',
      messagingSenderId: '781276801014',
      appId: '1:781276801014:web:e8bd6588c1177f3a7849d7',
      measurementId: 'G-94WZ8Z1GZ8'
  },
  filestackConfig: {
    apiKey: 'ARlI6nnkOSJqOMEJo5Clpz',
    appSecret: '5HBLGKB3RBAKLMQ35HUFTYQN3A'
  },
  allowTemplatesFeatureOnlyForTemplateAdmin: true,
  ALLOWED_TEMPLATE_ROLES: [
    "TemplateAdmin",
    "Admin",
    "OrganizationUser",
    "OrganizationAdmin",
  ],
  RESTRICTED_TEMPLATE_PLANS: [
    "starter",
    "growth",
    "lite",
    "starter_yearly",
    "growth_yearly",
    "business_yearly",
    "liteyearly",
    "trial",
  ],
  ALLOWED_TEMPLATE_PLANS: ["enterprise", "enterprise_yearly"],
  ALLOWED_STUDIO_ROLES: ["TemplateAdmin", "Admin"],
  ALLOWED_SUBSCRIPTION_ROLES: [
    "OrganizationAdmin",
    "Admin",
    "OrganizationUser",
    "SarasAdmin",
  ],
  ALLOWED_OLD_SUBSCRIPTION_ROLES: ["OrganizationAdmin", "Admin"],
  STUDIO_SOURCE_TYPE: "DEVSOURCETYPENEW",
  CDK_ENABLED_SOURCES: [
    "GITLABV2",
    "AIRCALL1",
    "SHIPSTATION",
    "KLAVIYOV2",
    "AIRCALL",
    "BIGCOMMERCE_CDK",
    "BOLRETAIL_CDK",
    "CALENDLY_V2",
    "CLICKUPV2",
    "MAILCHIMP1",
    "WALMART_CDK",
    "SUGARCRM",
    "BYRD",
    "SHOPIFY_V2",
    "AFTERSHIP_V2",
    "EASYPOST",
    "SKUBANA",
    "COMMISSIONJUNCTION",
    "INVENTORYPLANNER",
    "WOOCOMMERCE_CDK",
    "RECHARGEPAYMENTS_CDK",
    "TABOOLA",
    "SHIPHERO",
    "SHIPBOB",
  ],
  THRESHOLD: 100000,
  PRODUCTS: {
    DATON: 'https://devdaton.sarasanalytics.com/login',
    PULSE: 'https://dev-insights.sarasanalytics.com/login',
    INSIGHTS: 'https://dev-insights.sarasanalytics.com/login',
    SARAS: 'https://dev-accounts.sarasanalytics.com/auth',
  },
  PRODUCTFRUIT_KEY: 'AVO4gmb9QhCZigwH',
  PRODUCTFRUIT_LOCAL_KEY: 'W77iH8gIE8k6eHhg',
  pfCancellationSurveyId: '58298048-caca-441b-98e3-88546de07cea',
  isCACPhaseTwoFeatureEnabled: true,
  sentryDsn: "https://6d616948f3021e4efa9acc3dbb5519f9@o1070489.ingest.us.sentry.io/4510893918453760",
  recaptchaSiteKey: '6LcwBYgsAAAAAHmUKiH-R836O1-MOz-v-MAFSGgi',
  posthog: {
    apiKey: 'phc_oiZzNHsDGUfae8ZyiU7hY5mrAARxfXRBsP8Ms3yv3Upn',
    apiHost: 'https://replay.sarasanalytics.com',
  },
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
